export default {
  writing: 'operator_writing',
  nobodyWriting: 'nobody_writing'
}
